import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player'
import Slider from 'react-slick';

const VideoSlider = ({ videoUrls }) => {
    const [activeSlides, setActiveSlides] = useState({});
    const sliderRef = useRef(null);

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const settings = {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        arrows: true,
        dots: true,
        speed: 300,
        centerPadding: '0px',
        infinite: true,
        autoplaySpeed: 3000,
        autoplay: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 1292,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 1
                }
            },
        ]
    };

    const handleSlideChange = (currentSlide) => {
        setActiveSlides(prev => ({
            ...prev,
            [currentSlide]: true,
            [currentSlide - 1]: true,
            [currentSlide + 1]: true
        }));
    };
    useEffect(()=>{
        setWindowWidth(window.innerWidth);
    },[])

    return (
        <Slider ref={sliderRef} {...settings} afterChange={handleSlideChange}>
            {videoUrls.map((url, index) => (
                <div className="center-slider" key={index}>
                    <div id="outer">
                        <ReactPlayer
                            url={url}
                            width="587px"
                            height={windowWidth > 758?"350px":"250px"}
                            controls={true}
                            light={true}
                            playing={false}
                        />
                    </div>
                </div>
            ))}
        </Slider>
    );
};

export default VideoSlider;
